// Mirrors the Groups site's group-dining band: one continuous sand band holding
// the group dining copy and the booking prompt.
.band {
    background-color: var(--groups-sand);
    text-align: center;
}

.intro {
    margin: 0 auto;
    max-width: 1400px;
    padding: 4rem 1rem 0;

    @media (min-width: 640px) {
        padding: 5rem 1.5rem 0;
    }
}

.introAlone {
    padding-bottom: 5rem;

    @media (min-width: 640px) {
        padding-bottom: 6rem;
    }
}

.photo {
    border-radius: 16px;
    box-shadow: var(--groups-shadow-lift);
    display: block;
    height: auto;
    margin: 2.5rem auto 0;
    max-width: 56rem;
    object-fit: cover;
    width: 100%;
}

.body {
    margin: 2.5rem auto 0;
    max-width: 64rem;
}

.ctaRow {
    margin-top: 2rem;
}

.booking {
    margin: 0 auto;
    max-width: 64rem;
    padding: 3rem 1rem 5rem;

    @media (min-width: 640px) {
        padding: 3.5rem 1.5rem 6rem;
    }
}

// The booking heading uses the site's small-caps label treatment, in black so
// the prompt reads as part of group dining rather than a third section.
.eyebrow {
    font-family: var(--groups-font-sans);
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    margin: 0;
    text-transform: uppercase;

    @media (min-width: 640px) {
        font-size: 1.5rem;
    }
}

.bookingBody {
    margin: 1rem auto 0;
    max-width: 64rem;

    // Line breaks shape the prompt from 640px, as on the Groups site; phones
    // wrap freely. Editors type a space before each line break (Shift+Enter).
    @media (max-width: 639px) {
        br {
            display: none;
        }
    }
}

// The Group Dining site's 48 × 224px button, 32px below the prompt.
.bookingCta {
    margin-top: 2rem;
    text-align: center;
}
